import { StyleSheet } from 'aphrodite';
import { hexToRgbA, typography } from 'util/styleUtil';

const getSkin = (theme) => {
    const globalProfiles = theme.get('globalProfiles');
	const skin = globalProfiles.get('palette');
	const myTypography = typography(theme);

    return StyleSheet.create({
		title: {
			...myTypography.body2,
			opacity: 0.5,
			color: skin.get('grayColor2')
		},
		value: {
			...myTypography.body1,
			fontWeight: 600,
			color: skin.get('grayColor2')

		}
	});
}

export default getSkin;